import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let elements = document.querySelectorAll('.scroll-trigger');
if (elements.length > 0) {
    elements.forEach((element) => {
        gsap.timeline({
            scrollTrigger: {
                trigger: element,
                endTrigger: element,
                start: 'top 50%',
                end: 'bottom 50%',
                scrub: true,
                onToggle: function (self) {
                    if (!element.classList.contains('-animated') && self.isActive) {
                        element.classList.add("-animated");
                    }
                },
            }
        });
    });
}

if (document.querySelectorAll('.box-animate-stager').length > 0) {
    gsap.set('.box-animate-stager', {
        opacity: 0,
        y: 60,
        scale: 0.9,
    });
    let box_animate_stager = document.querySelectorAll('.box-animate-stager:not(.-animated)');
    box_animate_stager.forEach((element, index) => {
        gsap.timeline({
            scrollTrigger: {
                trigger: element,
                endTrigger: element,
                scrub: true,
                onToggle: function (self) {
                    if (!element.classList.contains('-animated') && self.isActive) {
                        gsap.to(element, {opacity: 1, y: 0, scale: 1, stagger: 0.2, delay: index * 0.15});
                        element.classList.add("-animated");
                    }
                },
            }
        });
    });
}